module.exports = __webpack_public_path__ + "img/Maneki-neko.4b26e1ea.png";